import { Outlet } from 'react-router-dom'

import { CompetenciesPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { AssessmentsProvider, useAssessments } from '../assessmentsContext'
import { CompetenciesProvider, useCompetencies } from '../competenciesContext'

const CompetenciesPage = () => {
  const { loading: loadingCompetencies } = useCompetencies()
  const { loading: loadingAssessments } = useAssessments()
  const { loading: loadingPolicies, data } = useQuery(CompetenciesPageDocument)

  const { navigation } = useNavigation()
  const canManageCompetencies = data?.competencies._policies.competenciesManage.can || false

  const loading = loadingCompetencies || loadingAssessments || loadingPolicies

  return (
    <ResponsivePage.Body
      showHeader={false}
      error={null}
      loading={loading}
      actions={
        canManageCompetencies
          ? {
              primary: [
                {
                  icon: 'settings',
                  to: navigation.competencies.fullPath(),
                  variant: 'secondary',
                  label: '',
                },
              ],
            }
          : undefined
      }
    >
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default function Competencies() {
  return (
    <CompetenciesProvider>
      <AssessmentsProvider>
        <CompetenciesPage />
      </AssessmentsProvider>
    </CompetenciesProvider>
  )
}
